import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/api.service';
import { ModalDescriptorComponent } from 'src/app/modals/database/modal-descriptor/modal-descriptor.component';

@Component({
  selector: 'database-descriptors',
  templateUrl: './database-descriptors.component.html',
  styleUrls: ['./database-descriptors.component.scss'],
})
export class DatabaseDescriptorsComponent implements OnInit, OnDestroy {
  types: Array<any> = [];
  subTypes: Array<any> = [];
  descriptors: Array<any> = [];

  langSub?: Subscription;

  constructor(
    private api: ApiService,
    private router: Router,
    private translate: TranslateService,
    private modalService: MdbModalService
  ) {}

  ngOnInit(): void {
    this.getType();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.getType();
    });
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  getType() {
    let databaseType: string = this.getCurrentLocation().toUpperCase();
    if (databaseType === 'CROP') databaseType = 'CROPS';
    if (databaseType === 'AQUACULTURE') databaseType = 'AQUATICS';

    this.api.getDescriptors(databaseType).subscribe((value) => {
      this.types = value as Array<any>;
    });
  }

  getCurrentLocation() {
    const path = this.router.url;
    return path.split('/')[3];
  }

  getImage() {
    const base: string = '/assets/images/';
    const location: string = this.getCurrentLocation();
    const image = base + location + '.svg';
    return image;
  }

  select = (i: number) => {
    this.types.filter((value) => {
      value.selected = false;
    });
    this.subTypes.filter((value) => {
      value.selected = false;
    });
    this.types[i].selected = true;
    this.subTypes = this.types[i].traitsSubtypesList;
    this.descriptors = [];
  };

  loadDescriptors(i: number, id: string) {
    this.descriptors = [];
    this.api.getDescriptorByCategory(id).subscribe((value) => {
      this.descriptors = value as Array<any>;
    });

    this.subTypes.filter((value) => {
      value.selected = false;
    });
    this.subTypes[i].selected = true;
  }

  openDescriptor(id: string) {
    this.modalService.open(ModalDescriptorComponent, {
      containerClass: 'right',
      modalClass: 'modal-side modal-bottom-right',
      data: { descriptorID: id },
    });
  }
}
